import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b6ff09fc")

_pushScopeId("data-v-b6ff09fc")
const _hoisted_1 = { class: "df-middle" }
const _hoisted_2 = {
  key: 0,
  class: "options"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")
  const _component_t = _resolveComponent("t")
  const _component_TheResolutionBar = _resolveComponent("TheResolutionBar")

  return (_openBlock(), _createBlock(_component_TheResolutionBar, null, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", {
          class: "select-wrap",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.listExpand = !_ctx.listExpand), ["stop"]))
        }, [
          (_ctx.listExpand)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.drawTypes, (item, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "opt-item df-middle",
                    key: index,
                    onClick: ($event: any) => (_ctx.$emit('draw', item.key))
                  }, [
                    _createVNode(_component_Pic, {
                      src: item.icon,
                      class: "mr-8",
                      width: "16",
                      height: "16"
                    }, null, 8, ["src"]),
                    _createVNode(_component_t, {
                      path: item.label
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(item.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["path"])
                  ], 8, ["onClick"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_3,
        _createVNode("div", {
          class: "rotate",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('fullscreen')))
        }, [
          _createVNode(_component_Pic, {
            src: "trade/rotate",
            width: "16",
            height: "16"
          })
        ])
      ])
    ]),
    _: 1
  }))
})